import { render, staticRenderFns } from "./ProjectWrite.vue?vue&type=template&id=4a2883cc&scoped=true&"
import script from "./ProjectWrite.vue?vue&type=script&lang=js&"
export * from "./ProjectWrite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2883cc",
  null
  
)

export default component.exports